import React, { Component } from 'react';
import { Form, message, Row } from 'antd';
import FlowSearch from '@comm/FlowSearch';
import '../expenses.less';
import { connect } from 'react-redux';
import { setBackInfo } from '@store/modules/back_info';
import { queryLoanList, querySaveWriteLoan } from '@api/finance/loan';
import TableExpenses from './TableExpenses';

class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        loading: false,
        pagination: {},
      },
    };
  }

  componentWillMount() {
    this.type = '0';
  }

  componentDidMount() {
    this.searchCondition = {};
    const { backInfo } = this.props;
    if (backInfo.path === this.props.route.path) {
      if (backInfo.start && backInfo.limit) {
        this.current = backInfo.start;
        this.pagination = {
          limit: backInfo.limit,
          start: backInfo.start,
        };
      }
      backInfo.condition && (this.searchCondition.condition = backInfo.condition);
      backInfo.createUser && (this.searchCondition.createUser = backInfo.createUser);
      backInfo.instanceStatus && (this.searchCondition.instanceStatus = backInfo.instanceStatus);
      backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
      backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
    }
    this.loadData();
  }

  componentWillUnmount() {
    const params = {
      path: this.props.route.path,
      ...this.searchCondition,
      ...this.pagination,
    };
    this.props.dispatch(setBackInfo(params));
  }

  setTableData = res => {
    this.setState({
      dataSource: {
        list: res.data,
        pagination: {
          total: res.totalSize,
          pageSize: 15,
          current: this.current,
        },
      },
    });
  };

  handleTableChange = pagination => {
    this.pagination = {
      limit: pagination.pageSize,
      start: pagination.current,
    };
    this.current = pagination.current;
    this.loadData();
  };

  handleSearch = params => {
    this.searchCondition = {
      ...params,
    };
    this.current = 1;
    this.pagination = {
      start: 1,
    };
    this.loadData();
  };

  getLoanList = params => {
    this.setState({ loading: true });
    queryLoanList(params).then(res => {
      if (res.statusCode === 200) {
        this.setTableData(res);
      }
      this.setState({ loading: false });
    });
  };

  loadData = () => {
    const params = {
      ...this.searchCondition,
      ...this.pagination,
    };
    this.getLoanList(params);
  };

  writeLoan = params => {
    querySaveWriteLoan(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.loadData();
      } else {
        message.error(res.message);
        this.loadData();
      }
    });
  };

  render() {
    const { loading, dataSource } = this.state;
    const parentProps = {
      loading,
      dataSource,
      writeLoan: this.writeLoan,
      onChange: this.handleTableChange,
    };
    return (
      <div>
        <Row>
          <FlowSearch onSearch={this.handleSearch} {...this.searchCondition} />
        </Row>
        <div id="ant-small-table">
          <TableExpenses {...parentProps} />
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  backInfo: state.back_info,
}))(Form.create({ wrappedComponentRef: true })(Manage));



// WEBPACK FOOTER //
// ./src/components/finance/loan/PageWatch.js